import React from 'react';
import { graphql, compose } from 'react-apollo';
import { assignmentPreviewDataOnly } from 'legacy-src/queries';

import PerformanceItem from './index';
import { parseNonEmptyJSONObject } from 'legacy-src/utility/utils';

/**
 * Wrapper for <PerformanceItem /> component. Loads data for teachers.
 * */
const TeacherWrapper = (props) => {
  const {
    subjectInfo,
    userData: {
      me: { isStudent },
      adminSubjects,
    },
    subjectData: { id: subjectId },
  } = props;

  return (
    <PerformanceItem
      showTags
      adminSubjectId={subjectInfo.initId}
      isStudent={isStudent}
      adminSubjects={adminSubjects}
      subjectId={subjectId}
      {...props}
    />
  );
};

TeacherWrapper.displayName = 'TeacherPerformanceItemWrapper';

const withAsessmentPreview = graphql(assignmentPreviewDataOnly, {
  options: ({ assignment }) => ({
    variables: {
      assignmentId: assignment.id,
      config: JSON.stringify({}),
      inline: true,
      showCorrectAnswers: true,
    },
  }),

  props: ({
    data: { assignment, assignmentPreview: assignmentPreviewData, error },
  }) => {
    if (error) {
      return {
        error: error.message,
      };
    }

    if (assignmentPreviewData) {
      const { learnositySignedRequest, scoringRubric } = assignmentPreviewData;
      return {
        studentResponses: parseNonEmptyJSONObject(assignment.studentResponses),
        scoringRubricResponses: parseNonEmptyJSONObject(
          assignment.scoringRubricResponses,
        ),
        learnosityServerData: JSON.parse(learnositySignedRequest),
        scoringRubric,
      };
    }
  },
});

export default compose(withAsessmentPreview)(TeacherWrapper);
